/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_MessageInputs */

const he_contact_form_message = /** @type {(inputs: Contact_Form_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הודעה`)
};

const en_contact_form_message = /** @type {(inputs: Contact_Form_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Contact_Form_MessageInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_form_message = /** @type {((inputs?: Contact_Form_MessageInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_MessageInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_form_message(inputs)
	return en_contact_form_message(inputs)
});